<img src="assets/icons/error.svg" width="20" height="20" alt="info" class="mb-auto" />
<p class="ml-2 text-jazlyn-100">{{ error.value }}</p>
